import React, { useEffect, useState } from "react";
import { Button, Input } from "@speedoc/design-assets";
import { useLocation } from "react-router-dom";
import URI from "urijs";
import { GlobalStore } from "../stores/global";

export default function PrivateLogin(props) {
  const isProduction = process.env.REACT_APP_BUILD_ENV === "production";
  const isDevelopment = process.env.NODE_ENV === "development";
  const uri = new URI(useLocation().pathname).segment(0);
  const passwordProtectedRoutes = GlobalStore.useState(c => c.passwordProtectedRoutes);
  const isPasswordProtected = passwordProtectedRoutes.indexOf(uri) > -1;
  const [isOpen, setIsOpen] = useState((isProduction && !isPasswordProtected) || isDevelopment);
  const [passKey, setPassKey] = useState(localStorage.getItem("speedoc-private-login-pwd"));
  const [feedbackMessage, setFeedbackMessage] = useState("");

  useEffect(() => {
    if (isOpen) return;
    setFeedbackMessage("");
    if (passKey === process.env.REACT_APP_LOGIN_KEY) {
      localStorage.setItem("speedoc-private-login-pwd", passKey);
      return setIsOpen(true);
    } else if (passKey) setFeedbackMessage("Invalid password...");
    setIsOpen(false);
  }, [passKey, isOpen]);

  const handlePasswordSubmit = e => {
    setPassKey(e.target.password.value);
    e.preventDefault();
  };

  if (isOpen) return props.children;

  return (
    <div id="privateLogin">
      <div className="content">
        <form onSubmit={handlePasswordSubmit}>
          <Input type="password" required name="password" placeholder="Preview password" />
          <Button type="submit" aria-label="private login submit button">
            Enter
          </Button>
        </form>
        <div className="feedback">{feedbackMessage ? <p>{feedbackMessage}</p> : null}</div>
      </div>
    </div>
  );
}
